module.exports = __webpack_public_path__ + "statics/img/help-bg.252a399f.png";